import React, { useState } from 'react'
import email_vector from "../assets/Landing_page/email_vector.png"
import phone_vector from "../assets/Landing_page/phone_vector.png"
import location_vector from "../assets/Landing_page/location_vector.png"
import home_vector from "../assets/Landing_page/home_vector.png"
import header_logo from "../assets/Landing_page/header_logo.png"
import burger_menu from "../assets/Landing_page/burger_menu.png"
import "./landingpage.css"
import { IoMdClose } from "react-icons/io";
import { Link } from 'react-router-dom'

const LandingHeader = () => {
    const [displayNav, setdisplayNav] = useState(false)

    return (
        <div className='header_container '>
            <div className='top_header_container '>
                <div className='left_container flex gap-[50px] items-center'>
                    <div className='flex items-center gap-2'><span><img src={email_vector} alt="email logo" /></span><span>lexilearn@orden.co.in</span></div>
                    {/* <div className='flex items-center gap-2'><span><img src={phone_vector} alt="email logo" /></span><span>98XXXXXXXX</span></div> */}
                    <div className='lg:flex items-center gap-2 hidden  '><span><img src={location_vector} alt="email logo" /></span><span>D-196, Sector-63, Noida-201 307, India</span></div>
                </div>

                <div className='right_container hidden lg:block'>
                    <div>
                        <Link to="/terms-and-conditions">
                            <span>Terms & conditions</span>
                        </Link>
                    </div>
                </div>

                <div className='right_container  lg:hidden'>
                    <div className='flex items-center gap-2  '><span><img src={location_vector} alt="email logo" /></span><span>D-196, Sector-63, Noida-201 307, India</span></div>

                </div>


            </div>

            <div className='lower_header sticky top-0'>
                <div className='logo'>
                    <a href="/">
                        <img src={header_logo} alt="home logo" />
                    </a>
                </div>

                <div className='nav_links' >
                    <ul className=''>
                        {
                            window.location.pathname === "/" ? (
                                <>

                                    <a href="/"><li><img src={home_vector} alt="home logo" /></li></a>
                                    {/* {window.location.pathname !== '/login'  && ( */}
                                    <>
                                        {/* <a href="/"><li onClick={() => setdisplayNav(false)}><img src={home_vector} alt="home logo" /></li></a> */}
                                        <a href="#about"><li onClick={() => setdisplayNav(false)}>About</li></a>
                                        <a href="#why-lexilearn"><li onClick={() => setdisplayNav(false)}>Why Lexilearn</li></a>
                                        <a href="#end-users"><li onClick={() => setdisplayNav(false)}>End Users</li></a>
                                        <a href="#how-it-works"><li onClick={() => setdisplayNav(false)}>How it works</li></a>
                                        <a href="#benefits"><li onClick={() => setdisplayNav(false)}>Benefits</li></a>
                                        <a href="#measures"><li onClick={() => setdisplayNav(false)}>Measures</li></a>
                                        <a href="#contact-us"><li onClick={() => setdisplayNav(false)}>Contact Us</li></a>
                                        <a href="/login"><li onClick={() => setdisplayNav(false)}>Login</li></a>
                                    </>
                                    {/* )} */}
                                </>
                            ) : (
                                <>
                                    <a href="/"><li><img src={home_vector} alt="home logo" /></li></a>
                                    <a href=""><li onClick={() => setdisplayNav(false)}>Subscribe</li></a>
                                </>
                            )
                        }
                        {/* <a href={window.location.pathname === '/login' ? '/contact-us' : '/login'}>
                            <li onClick={() => setdisplayNav(false)}>
                                {window.location.pathname === '/login' ? 'Contact Us' : 'Login'}
                            </li>
                        </a> */}
                    </ul>
                </div>

                <div className='burger_menu'>
                    <img onClick={() => setdisplayNav(true)} src={burger_menu} alt="burger menu" />
                </div>


                <div className={`${displayNav ? "block" : "hidden"}`}>
                    <div className='inset-0 fixed top-0 w-full h-100vh bg-white_color text-main_color p-[10px]'>
                        <div>
                            <div className='flex justify-end'>
                                <IoMdClose onClick={() => setdisplayNav(false)} size={30} />
                            </div>
                        </div>
                        <div className='mobile_menu_list_container flex justify-center text-[15px] font-semibold '>
                            <ul className=''>
                                {
                                    window.location.pathname === "/" ? (
                                        <>
                                            <a href="/"><li>Home</li></a>
                                            {/* {window.location.pathname !== '/login' && ( */}
                                            <>
                                                {/* <a href="/"><li onClick={() => setdisplayNav(false)}><img src={home_vector} alt="home logo" /></li></a> */}
                                                <a href="#about"><li onClick={() => setdisplayNav(false)}>About</li></a>
                                                <a href="#why-lexilearn"><li onClick={() => setdisplayNav(false)}>Why Lexilearn</li></a>
                                                <a href="#end-users"><li onClick={() => setdisplayNav(false)}>End Users</li></a>
                                                <a href="#how-it-works"><li onClick={() => setdisplayNav(false)}>How it works</li></a>
                                                <a href="#benefits"><li onClick={() => setdisplayNav(false)}>Benefits</li></a>
                                                <a href="#measures"><li onClick={() => setdisplayNav(false)}>Measures</li></a>
                                                <a href="#contact-us"><li onClick={() => setdisplayNav(false)}>Contact Us</li></a>
                                            </>
                                            {/* )} */}
                                            {/* <a href={window.location.pathname === '/login' ? '/contact-us' : '/login'}>
                                    <li onClick={() => setdisplayNav(false)}>
                                        {window.location.pathname === '/login' ? 'Contact Us' : 'Login'}
                                    </li>
                                </a> */}</>
                                    ) : (
                                        <>
                                            <a href="/"><li>Home</li></a>
                                        </>
                                    )
                                }

                            </ul>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    )
}

export default LandingHeader